/**
 * @deprecated event `keyCode` is deprecatd, so this shouldn't be used
 */
export var KeyCodes;
(function (KeyCodes) {
    KeyCodes[KeyCodes["DOWN_KEY_CODE"] = 40] = "DOWN_KEY_CODE";
    KeyCodes[KeyCodes["ESCAPE_KEY_CODE"] = 27] = "ESCAPE_KEY_CODE";
    KeyCodes[KeyCodes["ENTER_KEY_CODE"] = 13] = "ENTER_KEY_CODE";
    KeyCodes[KeyCodes["LEFT_KEY_CODE"] = 37] = "LEFT_KEY_CODE";
    KeyCodes[KeyCodes["RIGHT_KEY_CODE"] = 39] = "RIGHT_KEY_CODE";
    KeyCodes[KeyCodes["SPACE_KEY_CODE"] = 32] = "SPACE_KEY_CODE";
    KeyCodes[KeyCodes["TAB_KEY_CODE"] = 9] = "TAB_KEY_CODE";
    KeyCodes[KeyCodes["UP_KEY_CODE"] = 38] = "UP_KEY_CODE";
})(KeyCodes || (KeyCodes = {}));
